import { prepareCompanyImageFolderName, prepareImageFolderName } from "./Helpers";
import logger from "./LoggerFrontend";

export function getCompanyImageFolderName({ orgaId, companyId, orgaName, companyName, metadata }) {
  logger.log("getCompanyImageFolderName", "determining folder name", {
    orgaId,
    companyId,
    orgaName,
    companyName,
    metadata
  });

  if (companyId) {
    return prepareCompanyImageFolderName(orgaId, companyId, metadata);
  }

  logger.warn("getCompanyImageFolderName", "company not found using fallback", {
    orgaId,
    companyId,
    orgaName,
    companyName,
    metadata
  });

  return prepareImageFolderName(orgaName, companyName, metadata);
}
